import { NextPage } from 'next';
import { useState } from 'react';
import Layout from '../react-components/layout';
import fullWidthCard from '../styles/full-width-card.module.css';
import ButtonWithFeedback from '../react-components/button-with-feedback';
import { useRequest } from '../utils/make-api-request';

const getRole = () => new URLSearchParams(window.location.search).get('role');

const PasswordReset: NextPage = () => {
  const [email, setEmail] = useState('');
  const [resetPasswordRequest, resetPassword] = useRequest('password-reset-tokens', 'post');
  const done = resetPasswordRequest.data !== undefined;
  return (
    <Layout>
      {done ? (
        <>
          <h1>All Set!</h1>
          <p>Check your email for a link to finish resetting your password.</p>
        </>
      ) : (
        <form
          onSubmit={e => {
            e.preventDefault();
            resetPassword({ email, role: getRole() });
          }}
          className={fullWidthCard.fullWidthCard}
        >
          <h1>Reset your Password</h1>
          <div className='my-4'>
            <input value={email} onChange={e => setEmail(e.target.value)} required placeholder='Email' type='email' />
          </div>
          <ButtonWithFeedback request={resetPasswordRequest} type='submit' className='primary instant-touch'>
            Send Email
          </ButtonWithFeedback>
        </form>
      )}
    </Layout>
  );
};

export default PasswordReset;
